import { MissionHeader } from '@/features/missions/components/MissionHeader'
import { MissionsUrlProvider } from '@/features/missions/context/MissionsUrlProvider'
import { MissionsForAuthorizedUser } from '@/features/missions/MissionsWrappers'
import { Page } from '@/ui-kit'

const MissionsWebviewPage = () => {
  return (
    <MissionsUrlProvider isWebview={true}>
      <Page>
        <div className="flex flex-col gap-4 py-4">
          <MissionHeader title={<div className="text-h5 text-gray-70 mt-2 font-semibold">Missions</div>} />
          <MissionsForAuthorizedUser />
        </div>
      </Page>
    </MissionsUrlProvider>
  )
}

export default MissionsWebviewPage
